<template>
  <b-input-group>
    <div id="schoolCheck" class="mt-1">
      <div>
        <input type="checkbox" class="ml-1" v-model="page.selectAllElSchools"
            id="allElSchools" :disabled="page.elSchoolDisabled">
        <label class="font-weight-bold ml-1 mr-1" for="allElSchools">초등</label>
        <template v-for="(item) in page.elSchoolItems">
          <input type="checkbox" class="ml-1" v-model="params.selectedSchools" :value="item.key"
            :id="item.key" :disabled="page.elSchoolDisabled" :key="item.key+'input'">
          <label class="form-check-label ml-1" :key="item.key+'label'" :for="item.key">{{item.text}}</label>
        </template>
      </div>
      <div>
        <input type="checkbox" class="ml-1" v-model="page.selectAllMidSchools"
            id="allMidSchools" :disabled="page.midSchoolDisabled">
        <label class="font-weight-bold ml-1 mr-1" for="allMidSchools">중등</label>
        <template v-for="(item) in page.midSchoolItems">
          <input type="checkbox" class="ml-1" v-model="params.selectedSchools" :value="item.key"
            :id="item.key" :disabled="page.midSchoolDisabled" :key="item.key+'input'">
          <label class="form-check-label ml-1" :key="item.key+'label'" :for="item.key">{{item.text}}</label>
        </template>
      </div>
      <div>
        <input type="checkbox" class="ml-1" v-model="page.selectAllHighSchools"
            id="allHighSchools" :disabled="page.highSchoolDisabled">
        <label class="font-weight-bold ml-1 mr-1" for="allHighSchools">고등</label>
        <template v-for="(item) in page.highSchoolItems">
          <input type="checkbox" class="ml-1" v-model="params.selectedSchools" :value="item.key"
            :id="item.key" :disabled="page.highSchoolDisabled" :key="item.key+'input'">
          <label class="form-check-label ml-1" :key="item.key+'label'" :for="item.key">{{item.text}}</label>
        </template>
      </div>
    </div>
  </b-input-group>
</template>

<script>
import {reactive, ref, computed, watch, onMounted} from '@vue/composition-api';
import {allSchoolItems} from "@/utils/Constants";

// 1. params.selectedSchools 배열에 선택된 체크박스의 키값을 넣어준다. 
// 2. params[선택된키값] = 'Y', params[그외키값] = 'N'로 설정한다.
// 3. 'schoolType' 이벤트 전송 : 'none', 'el', 'mid', 'high' 중 한개의 값
export default {
  props: {
    params: {}
  },
  components: {},
  setup(props, context) {
    const elSchoolItems = allSchoolItems.filter((item) => item.key.indexOf('schlE') > -1);
    const midSchoolItems = allSchoolItems.filter((item) => item.key.indexOf('schlM') > -1);
    const highSchoolItems = allSchoolItems.filter((item) => item.key.indexOf('schlH') > -1);
    const allSchoolKeys = allSchoolItems.map((item) => item.key);
    const elSchoolKeys = elSchoolItems.map((item) => item.key);
    const midSchoolKeys = midSchoolItems.map((item) => item.key);
    const highSchoolKeys = highSchoolItems.map((item) => item.key);

    const params = props.params;

    const _page = {
      allSchoolKeys: allSchoolKeys,
      elSchoolKeys: elSchoolKeys,
      midSchoolKeys: midSchoolKeys,
      highSchoolKeys: highSchoolKeys,
      elSchoolItems : elSchoolItems,
      midSchoolItems : midSchoolItems,
      highSchoolItems : highSchoolItems,
    }
    _page.selectAllElSchools = computed({
      get() {
        let allSelected = true;
        page.elSchoolKeys.forEach((key) => {
          if (!params.selectedSchools.includes(key)) {
            allSelected = false;
          }
        });
        return allSelected;
      },
      set(newValue) {
        let selected = [];
        if (newValue) {
          page.elSchoolKeys.forEach(key => {
            selected.push(key);
          });
        }
        params.selectedSchools = selected;
      }
    });
    _page.selectAllMidSchools = computed({
      get() {
        let allSelected = true;
        page.midSchoolKeys.forEach((key) => {
          if (!params.selectedSchools.includes(key)) {
            allSelected = false;
          }
        });
        return allSelected;
      },
      set(newValue) {
        let selected = [];
        if (newValue) {
          page.midSchoolKeys.forEach(key => {
            selected.push(key);
          });
        }
        params.selectedSchools = selected;
      }
    });
    _page.selectAllHighSchools = computed({
      get() {
        let allSelected = true;
        page.highSchoolKeys.forEach((key) => {
          if (!params.selectedSchools.includes(key)) {
            allSelected = false;
          }
        });
        return allSelected;
      },
      set(newValue) {
        let selected = [];
        if (newValue) {
          page.highSchoolKeys.forEach(key => {
            selected.push(key);
          });
        }
        params.selectedSchools = selected;
      }
    });
    _page.elSchoolDisabled = computed(() => {
      if (params.selectedSchools.length == 0) {
        return false;
      }
      let disabled = true;
      params.selectedSchools.forEach((key) => {
        elSchoolItems.forEach((item) => {
          if (item.key == key) {
            disabled = false;
          }
        });
      });
      return disabled;
    });
    _page.midSchoolDisabled = computed(() => {
      if (params.selectedSchools.length == 0) {
        return false;
      }
      let disabled = true;
      params.selectedSchools.forEach((key) => {
        midSchoolItems.forEach((item) => {
          if (item.key == key) {
            disabled = false;
          }
        });
      });
      return disabled;
    });
    _page.highSchoolDisabled = computed(() => {
      if (params.selectedSchools.length == 0) {
        return false;
      }
      let disabled = true;
      params.selectedSchools.forEach((key) => {
        highSchoolItems.forEach((item) => {
          if (item.key == key) {
            disabled = false;
          }
        });
      });
      return disabled;
    });
    const page = reactive(_page);

    const setSchoolParams = () => {
      page.allSchoolKeys.forEach((key) => {
        params[key] = 'N';
      })
      params.selectedSchools.forEach((key) => {
        params[key] = 'Y';
      })
    };

    onMounted(() => {
    });
    
    watch(() => params.selectedSchools, async (schools, oldSchools) => {
      setSchoolParams();
      // 학교급이 변경된 경우 과목 초기값 설정
      if (schools.length == 0) {
        context.emit('schoolType', 'none');
      } else if (!oldSchools.some((key) => elSchoolKeys.includes(key)) && schools.some((key) => elSchoolKeys.includes(key))) {
        context.emit('schoolType', 'el');
      } else if (!oldSchools.some((key) => midSchoolKeys.includes(key)) && schools.some((key) => midSchoolKeys.includes(key))) {
        context.emit('schoolType', 'mid');
      } else if (!oldSchools.some((key) => highSchoolKeys.includes(key)) && schools.some((key) => highSchoolKeys.includes(key))) {
        context.emit('schoolType', 'high');
      } 
    });

    return {
      page
    }
  }
}

</script>
